import axios from 'axios';
import _ from 'lodash';
import DomainNameAPI from '../constants/DomainNameAPI';
import LoginService from '../utils/login-service';
import Topics from '../constants/Topics';
import Constants from '../constants/Constants';
import ReactDOM from 'react-dom';

const apiError = Constants.API_SERVER_ERROR;

export let getYearsAndTypes = async (argsObject) => {
  //this service depends on getyears service and getyearstypes service and publishes a single data object

  if (_.isNil(argsObject.orgId) || _.isNil(argsObject.Api)) {
    throw new Error('getYearsAndTypes call requires orgId and Api');
  }

  let Api = argsObject.Api;

  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: true });

  let yearsData = await getYears(argsObject);

  let clientTypesData;

  if (!_.isNil(yearsData))
    clientTypesData = await getYearTypes({
      orgId: argsObject.orgId,
      years: yearsData.years,
      Api,
    });
  else {
    yearsData = { years: [] };
    clientTypesData = { clientTypes: [] };
  }

  let matchData;

  try {
    //clienttypes obj from yearsdata exists, and is equivalent, for all years, just use first one
    matchData = JSON.parse(yearsData.years[0].clientTypes);
  } catch (e) {
    matchData = {};
    console.log(e);
    showError(apiError);
    argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    return { apiFailed: true };
  }

  // do logic for getS3Clients call
  let s3ActiveObject = {};

  let appArray = [];

  clientTypesData.clientTypes.forEach((type) => {
    if (type.accStatus === 'active' && !_.includes(appArray, type.clientType)) appArray.push(type.clientType);
  });

  let appString = '';

  appArray.forEach((app) => {
    appString = appString + `${app},`;
  });

  appString = appString.slice(0, -1);
  try {
    for (let year of yearsData.years) {
      let s3Active = await getS3Clients({
        orgId: argsObject.orgId,
        year: year.academicYear,
        clientTypesData,
        Api: Api,
        application: appString,
        clientMosObjList: clientTypesData.clientMosObjList,
      });

      s3ActiveObject = { ...s3ActiveObject, [year.academicYear]: s3Active };
    }
  } catch (err) {
    // catch err and let is go when the application is empty.
    // We need to avoid to call getS3Client since application is required
    // Fixing the error for Jira ENROLLMENT-25793
  }

  let dataObj = {
    years: yearsData.years,
    clientTypes: clientTypesData.clientTypes,
    yearsDisplayData: matchData,
    s3Active: s3ActiveObject,
    clientMosObjList: clientTypesData.clientMosObjList,
  };

  Api.Publish(Topics.YEARS_TYPES_DISPLAY, dataObj);
  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
};

export let getYears = (argsObject) => {
  //this service returns a value because another service depends on it

  if (_.isNil(argsObject.orgId) || _.isNil(argsObject.Api)) {
    throw new Error('getYears call requires orgId and Api');
  }

  let varEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
  let baseUrl = DomainNameAPI[varEnv].YEARS_SERVICE_BASEURL;
  let options = `orgId=${argsObject.orgId}&year=${process.env.REACT_APP_REF_YEAR}&inValidCaching=false`; //eslint-disable-line no-undef

  let url = `${baseUrl}${options}`;

  return axios({
    method: 'GET',
    url: url,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      //'X-CB-Catapult-Authentication-Token' : 'CBLogin ' + cb.core.iam.getAuthSession().sessionId,
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      //'X-CB-Catapult-Authorization-Token': cb.core.iam.getJWTToken()
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then((res) => {
      let data = res.data;

      let yearsUnsorted = data.years.map((year) => {
        return _.pick(
          year,
          'academicYear',
          'yearOrderId',
          'thisYear',
          'lastYear',
          'nextYear',
          'olderYear',
          'cutOffDate',
          'clientTypes'
        );
      });

      let years = yearsUnsorted.sort((a, b) => {
        // ascending by yearorderid
        return a.yearOrderId - b.yearOrderId;
      });

      argsObject.Api.Publish(Topics.ORG_YEARS, { years });
      return { years }; //return is used by getyearsandTypes service
    })
    .catch((err) => {
      console.log('DEBUG error', err);
      showError(apiError);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
      throw new Error(apiError);
    });
};

export let getYearTypes = (argsObject) => {
  // this service returns a value because another service depends on it

  if (_.isNil(argsObject.orgId) || _.isNil(argsObject.years) || _.isNil(argsObject.Api)) {
    throw new Error('getYearTypes call requires orgId, years, and Api');
  }

  let Api = argsObject.Api;
  let orgId = argsObject.orgId;
  let years = argsObject.years;

  let varEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
  var api_type_base_url = DomainNameAPI[varEnv].TYPES_SERVICE_BASEURL;

  let getUrl = (year) => {
    let url = `${api_type_base_url}orgId=${orgId}&year=${year}`;
    return url;
  };

  let getRequest = (url) => {
    return axios({
      method: 'GET',
      url: url,
      timeout: 15000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        //'X-CB-Catapult-Authentication-Token': 'CBLogin ' + cb.core.iam.getAuthSession().sessionId,
        //'X-CB-Catapult-Authorization-Token': cb.core.iam.getJWTToken()
        'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
        'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
      },
    });
  };

  let getRequests = (years) => {
    return years.map((year) => {
      return getRequest(getUrl(year.academicYear));
    });
  };

  return Promise.all(getRequests(years)).then((resps) => {
    let types = [];

    resps.forEach((res) => {
      types = types.concat(res.data);
    });
    let clientMosObjList = {};
    if (types) {
      types.map((t) => {
        if (t.academicYear >= 2223 && t.mos) {
          clientMosObjList[t.clientType] = { mos: t.mos };
        }
      });
    }

    Api.Publish(Topics.YEARS_TYPES, { clientTypes: types });
    return { clientTypes: types, clientMosObjList: clientMosObjList }; // return is used by getyearsandtypes service
  });
};

export let getS3Clients = (argsObject) => {
  if (
    _.isNil(argsObject.orgId) ||
    _.isNil(argsObject.year) ||
    _.isNil(argsObject.application) || _.isEmpty(argsObject.application) ||
    _.isNil(argsObject.Api)
  ) {
    throw new Error('getYearTypes call requires orgId, years, and Api');
  }

  const { orgId, year, application, Api, clientMosObjList } = argsObject;

  let varEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
  let baseUrl = DomainNameAPI[varEnv].CLIENTS_SERVICE_BASEURL;
  let options = `orgId=${orgId}&application=${application}&year=${year}&clientMosObjList=${encodeURIComponent(
    JSON.stringify(clientMosObjList)
  )}&inValidCaching=false`; //eslint-disable-line no-undef

  let url = `${baseUrl}${options}`;

  return axios({
    method: 'GET',
    url: url,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      //'X-CB-Catapult-Authentication-Token' : 'CBLogin ' + cb.core.iam.getAuthSession().sessionId,
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      //'X-CB-Catapult-Authorization-Token': cb.core.iam.getJWTToken()
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then((res) => {
      //console.log(`debug s3 res: `, res.data)
      Api.Publish(Topics.S3_ACTIVE, res.data);
      return res.data;
    })
    .catch((err) => {
      console.log('DEBUG error', err);
      // showError(apiError);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
      throw new Error(apiError);
    });
};

const showError = (error) => {
  const errorMessage = error;
  ReactDOM.render(
    <div className="Error" style={{ color: 'black' }}>
      <h4>
        {errorMessage && (
          <div style={{ color: 'black' }} className="error">
            {' '}
            {errorMessage}{' '}
          </div>
        )}
      </h4>
    </div>,
    document.getElementById('root')
  );
};
